<template>
	<div class="paginator">
		<div v-if="totalPages > FIRST_PAGE" class="paginator__elm">
			<!-- //////////////// -->
			<!-- Переход на первую страницу -->
			<div
				v-if="
					totalPages > 2 &&
					currentPage !== FIRST_PAGE &&
					currentPage > SECOND_PAGE
				"
				@click="onClick(FIRST_PAGE, S_TO_FIRST_PAGE)"
				class="paginator__elm-item"
			>
				<IconDoubleChevron />
			</div>

			<!-- //////////////// -->
			<!-- Счётчик на 1 меньше -->
			<div
				@click="onClick(ZERO, S_DECREMENT_PAGE)"
				class="paginator__elm-item paginator__elm_incdec"
				v-if="currentPage !== FIRST_PAGE"
			>
				<IconChevron />
			</div>
			<div
				:class="
					currentPage === page + count
						? 'paginator__elm-item paginator__elm-item_green'
						: 'paginator__elm-item'
				"
				@click="onClick(page + count, index)"
				v-for="(page, index) in total"
				:key="index"
			>
				{{ page + count }}
			</div>

			<div v-if="totalPages - 2 > currentPage">
				<div
					v-if="totalPages > NUMBER_OF_CELL"
					class="paginator__elm-item"
				>
					...
				</div>
			</div>

			<div
				v-if="totalPages > 3"
				@click="onClick(totalPages, S_LAST_PAGE)"
				:class="
					currentPage === totalPages
						? 'paginator__elm-item paginator__elm-item_green'
						: 'paginator__elm-item'
				"
			>
				{{ totalPages }}
			</div>

			<!-- //////////////// -->
			<!-- Счётчик на 1 больше -->
			<div
				class="paginator__elm-item paginator__elm_incdec"
				@click="onClick(ZERO, S_INCREMENT_PAGE)"
				v-if="currentPage !== totalPages"
			>
				<IconChevron class="paginator__elm-item-chevron_right" />
			</div>

			<!-- //////////////// -->
			<!-- Переход на последнюю страницу -->
			<div
				class="paginator__elm-item"
				@click="onClick(totalPages, S_LAST_PAGE)"
				v-if="
					currentPage !== totalPages && currentPage !== totalPages - 1
				"
			>
				<IconDoubleChevron class="paginator__elm-item-chevron_right" />
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconDoubleChevron from "@/components/icons/IconDoubleChevron.vue";
import IconChevron from "@/components/icons/IconChevron.vue";

@Options({
	components: { IconChevron, IconDoubleChevron },
	props: {
		totalPages: { type: Number, default: 1 },
		currentPage: { type: Number, default: 1 },
	},
})
export default class Paginator extends Vue {
	public totalPages: number;
	public currentPage: number;
	public count = 0;

	// Константы
	public ZERO = 0;
	public NUMBER_OF_CELL = 4; // Количество отображаемых ячеек, когда выбрана последняя страница
	public FIRST_PAGE = 1;
	public SECOND_PAGE = 2;
	public THIRD_PAGE = 3;

	public S_TO_FIRST_PAGE = -2;
	public S_DECREMENT_PAGE = -1;
	public S_INCREMENT_PAGE = 3;
	public S_LAST_PAGE = 4;

	/**
	 * Выбор страницы
	 * @param page
	 * @param section
	 */
	public onClick(page: number, section: number) {
		switch (true) {
			//////////////////////////
			// << на первую страницу
			case section === -2 && page === 1:
				this.count = this.ZERO;
				break;
			//////////////////////////
			// < на одну станицу назад
			case section === -1:
				if (this.currentPage !== this.FIRST_PAGE) {
					page = this.currentPage - 1;
				} else {
					page = this.currentPage;
				}
				if (
					this.currentPage > this.SECOND_PAGE &&
					this.currentPage < this.totalPages - 1
				) {
					this.count -= 1;
				}
				break;
			//////////////////////////
			// первая кнопка
			case section === this.ZERO && page > 1:
				this.count -= 1;
				break;
			//////////////////////////
			// третья кнопка
			case section === 2 &&
				this.totalPages > 1 &&
				this.totalPages < this.NUMBER_OF_CELL:
				this.count = this.ZERO;
				break;
			case section === 2:
				if (this.totalPages - 1 !== page) {
					this.count += 1;
				}
				break;

			//////////////////////////
			// > на одну станицу вперед
			case section === 3:
				page = this.currentPage + 1;
				if (this.totalPages < page) {
					page = this.currentPage;
				}
				if (
					this.currentPage > 1 &&
					this.currentPage < this.totalPages - 2
				) {
					this.count += 1;
				}
				break;

			//////////////////////////
			// >> переход на последнюю страницу
			case section === 4 && this.totalPages - 2 > this.currentPage:
				if (this.currentPage < 3) {
					this.count += this.totalPages - this.NUMBER_OF_CELL;
				} else {
					this.count +=
						this.totalPages -
						this.NUMBER_OF_CELL -
						this.currentPage +
						this.SECOND_PAGE;
				}
				break;
		}

		this.$emit("selected-page", page);
	}

	/**
	 * Если значение totalPages больше 2, тогда свойство total = 3
	 * Иначе вернет totalPages
	 */
	public get total() {
		switch (true) {
			case this.currentPage > this.SECOND_PAGE &&
				this.currentPage < this.totalPages - this.SECOND_PAGE:
				this.count = Number(this.$route.query.page) - this.SECOND_PAGE;
				break;

			case this.currentPage > this.SECOND_PAGE &&
				this.currentPage < this.totalPages - this.FIRST_PAGE:
				this.count = Number(this.$route.query.page) - this.SECOND_PAGE;
				break;

			case this.currentPage > this.SECOND_PAGE &&
				this.currentPage === this.totalPages - this.FIRST_PAGE &&
				this.totalPages > this.THIRD_PAGE:
				this.count = this.totalPages - this.NUMBER_OF_CELL;
				break;

			case this.currentPage > this.SECOND_PAGE &&
				this.currentPage === this.totalPages &&
				this.totalPages > this.THIRD_PAGE:
				this.count = this.totalPages - this.NUMBER_OF_CELL;
				break;

			default:
				this.count = 0;
		}

		return this.totalPages > this.SECOND_PAGE
			? this.THIRD_PAGE
			: this.totalPages;
	}
}
</script>

<style scoped lang="scss">
.paginator {
	user-select: none;

	&__elm {
		display: flex;
		padding: 24px;
	}

	&__elm-item {
		display: flex;
		font-size: 13px;
		font-weight: 600;
		align-items: center;
		justify-content: center;
		padding: 6px;
		margin-right: 6px;
		border-radius: 8px;
		border: 1px solid rgb(241, 241, 241);
		background: rgb(255, 255, 255);
		color: rgb(51, 51, 51);
		min-width: 20px;
		min-height: 20px;
		cursor: pointer;
	}

	&__elm-item_green {
		background: var(--theme-color);
		color: rgb(255, 255, 255);
	}

	&__elm-item-chevron_right {
		transform: rotate(0.5turn);
	}

	// Для моб.
	@media screen and (max-width: 768px) {
		&__elm {
			padding: 0 16px;
		}
		&__elm-item {
			padding: 8px;
		}

		&__elm_incdec {
			display: none;
		}
	}
}
</style>
